import {
  REPORT_SALES_DAILY,
  REPORT_PAYMENTS_DAILY,
  RECEIPTS_REPORT,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestReportSalesDaily = async () => (
  request.get(REPORT_SALES_DAILY)
    .then((resp) => resp.data.data)
    .catch((error) => formatError(error))
)

export const requestReportPaymentsDaily = async () => (
  request.get(REPORT_PAYMENTS_DAILY)
    .then((resp) => resp.data.data)
    .catch((error) => formatError(error))
)

export const requestReportPaymentsRange = async (params) => (
  request.get(RECEIPTS_REPORT, { params })
    .then((resp) => resp.data.data)
    .catch((error) => formatError(error))
)
